import { gql } from '@apollo/client';

const getNoWinNoFeePage = () => ({
  query: gql`
    {
      acfOptionsNowinnofeepage {
        nowinnofeepage {
          banner {
            bannerImageDesktop {
              sourceUrl
            }
            bannerImageMobile {
              sourceUrl
            }
            bannerTitle
            bannerDescription
          }
          whatIsNoWinNoFee
          areYouEligibleSection {
            title
            image {
              sourceUrl
            }
            description
          }
          understandingNoWinNoFee
          getStartedSection {
            image {
              sourceUrl
            }
            contentWithLink
          }
          faq
          reviewSection {
            title
            description
            subtitle
            subDescription
            bottomParagraph
          }
          awardSection {
          title
          leftImage {
            sourceUrl
          }
          leftImageDescription
          rightImage {
            sourceUrl
          }
          rightImageDescription
          }
        }
      }
    }
  `,
});

export default getNoWinNoFeePage;
